import { useMutation } from "@tanstack/react-query";
import { trainerAccountApi } from "api/trainers/trainerAccountApi";

export const useBulkSendTrainerInvite = () => {
  return useMutation({
    mutationFn: (trainerIds: number[]) => trainerAccountApi.bulkSendInvite(trainerIds),
  });
};
